import Ajax from '../../../../util/ajax';
export function zigbeeSetPinCode(nid, eid, payload) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/0x0101/command/set-pin-code';
        const value = {
            'userID': payload.userID,
            'code': payload.code
        };
        ajax.post(url, value);
    };
}
